var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonorail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    className: "iconify iconify--emojione-monotone",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 45.466h7.5V62h1.348V45.466h4.687V62h1.466V45.466H28.25V62h1.348V45.466h4.687V62h1.465V45.466H47V62h1.348V45.466h4.687V62H54.5V45.466H62V44.06H2zM4.813 36.527h3.75v1.875h-3.75zM12.313 36.527h3.75v1.875h-3.75z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24.092H9.741c0-.648.23-1.406.632-2.232 3.065-.843 14.053-3.727 20.743-3.727 2.273 0 4.208-6.999 4.208-10.316 0-2.614-1.008-2.95-4.302-2.993C32.41 4.302 33.67 4 34.707 4H62V2H34.707C26.846 2 7.741 16.728 7.741 24.092c0 2.346 3.78 6.95 9.735 10.124H2v.938h17.406c1.196.53 2.464.995 3.79 1.374h-3.383v1.875h3.75V36.63c1.203.326 2.458.57 3.75.733v1.04h3.75v-.123a25.27 25.27 0 0 0 2.287 1.561H2v3.281h60v-7.528H37.861c-3.092-1.35-5.265-3.32-7.277-5.155-1.336-1.217-2.639-2.396-4.091-3.289H62v-3.058M27.684 35.393c-4.301-.529-8.088-2.146-11.064-4.038h3.747c2.878-.001 4.839 1.781 7.317 4.038",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62 4.816H46.834c-5.57 0 7.242 15.272 12.061 15.272H62V4.816zM37.014 16.415a2.72 2.72 0 0 0 5.438 0v-8.88a2.719 2.719 0 1 0-5.438 0v8.88",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonorail);
export default __webpack_public_path__ + "static/media/monorail.b8a979200243f6edf548f1e212f5b77f.svg";
export { ForwardRef as ReactComponent };